import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  columnsAverageYearDemand,
  listDataAverageYearDemand,
} from "./data/AverageYearDemand";
import { columnsPerformance, listDataPerformance } from "./data/Performance";
// import {
//   GET_DT_BALANCE_COLUMN,
//   GET_DT_BALANCE_ZONE,
//   GET_SHIPPER,
//   GET_SHIPPER_BY_BOOKING
// } from "helpers/url_api_constant";

import AverageYearDemand from "./tab/AverageYearDemand";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import GasDelivery from "./tab/GasDeliveryPlan";
import Performance from "./tab/Performance"
import PipelineCapacity from "./tab/PipelineCapacity";
import AccImbalance from "./tab/AccImbalance";
import PropTypes from "prop-types";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import moment from "moment";
import classnames from "classnames";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { DatePicker } from "antd";
import { post } from "helpers/api_helper";
// import OverButton from "../../components/Custom/Overbutton";

const generateYearList = () => {
  const currentYear = new Date().getFullYear();
  let years = [];
  for (let index = currentYear - 4; index <= currentYear; index++) {
    years.push({ label: index, value: index });
  }
  return years;
};
const currentYear = new Date().getFullYear();

//i18n
function OtherKeyinData(props) {
  const [activeTab, setActiveTab] = useState("1");

  const [pageDataConfirmModal, dataConfirmModal] = useState(false);
  const [listYear, setListYear] = useState(generateYearList());
  // DropDown Search
  const [yearSelected, setYearSelected] = useState({
    label: currentYear,
    value: currentYear,
  });


  // Handle Set Value DropDown Search //
  const handleSelectedYear = selected => {
    setYearSelected(selected);
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "Id",
      order: "asc",
    },
  ];

  //headerColumn
  const addHeaderTableAverageYearDemand = () => {
    let thead = document
      .getElementById("flow-selection-table-5")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="26" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Average Year Demand</th>';
    thead.prepend(tr);
  };

  const addHeaderTablePerformance = () => {
    let thead = document
      .getElementById("flow-selection-table-6")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="26" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Performance</th>';
    thead.prepend(tr);
  };

  //onInit//
  useEffect(function () {
    setYearSelected({ label: currentYear, value: currentYear });
    // addHeaderTableAverageYearDemand();
    // addHeaderTablePerformance();
  }, []);
  //onInit//

  // useEffect(() => {
  //   getTableData();
  // }, [dateSelected]);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody>
 
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Other Key-in Data")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Manual Data Entry
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Other Key-in Data
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">

                          <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                              {/* <FormGroup className="row">
                                <Col
                                  sm={9}
                                  className=" d-flex align-items-center justify-content-end"
                                >
                                  <h5> Data Year :</h5>
                                </Col>
                                <Col>
                                  <Select
                                    placeholder="Select Year"
                                    value={yearSelected}
                                    onChange={handleSelectedYear}
                                    options={listYear}
                                    classNamePrefix="select2-selection"
                                  />
                                </Col>
                              </FormGroup> */}
                            </TabPane>
                            <TabPane tabId="4">
                              {/* <FormGroup className="row">
                                <Col
                                  sm={9}
                                  className=" d-flex align-items-center justify-content-end"
                                >
                                  <h5> Data Year :</h5>
                                </Col>
                                <Col>
                                  <Select
                                    placeholder="Select Year"
                                    value={yearSelected}
                                    onChange={handleSelectedYear}
                                    options={listYear}
                                    classNamePrefix="select2-selection"
                                  />
                                </Col>
                              </FormGroup> */}
                            </TabPane>
                          </TabContent>

                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                                // dataConfirmModal(true);
                              }}
                            >
                              Gas Delivery Plan
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                setActiveTab("2");
                                // dataConfirmModal(true);
                              }}
                            >
                              Pipeline Capacity
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                setActiveTab("3");
                                // dataConfirmModal(true);
                              }}
                            >
                              Average Year Demand
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "4",
                              })}
                              onClick={() => {
                                setActiveTab("4");
                                // dataConfirmModal(true);
                              }}
                            >
                              Performance
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "5",
                              })}
                              onClick={() => {
                                setActiveTab("5");
                                // dataConfirmModal(true);
                              }}
                            >
                              Acc.Imbalance
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row>

                      <Row>
                        <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1">
                            <GasDelivery />
                            {/* yearSelected={yearSelected.value} */}

                          </TabPane>

                          <TabPane tabId="2">
                            <PipelineCapacity />


                            {/* <Col sm="12">
                              <div>
                                <BootstrapTable
                                  id="flow-selection-table-4"
                                  keyField="Id"
                                  data={listDataPipelineCapacity}
                                  columns={columnsPipelineCapacity}
                                  headerClasses="header-style"
                                  // rowStyle={RowStyleFontWhite}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  hover
                                />
                              </div>
                            </Col> */}
                          </TabPane>

                          <TabPane tabId="3">
                            <AverageYearDemand />

                            {/* <Col sm="12">
                              <div>
                                <BootstrapTable
                                  id="flow-selection-table-5"
                                  keyField="Id"
                                  data={listDataAverageYearDemand}
                                  columns={columnsAverageYearDemand}
                                  headerClasses="header-style"
                                  // rowStyle={RowStyleFontWhite}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  hover
                                />
                              </div>
                            </Col> */}
                          </TabPane>

                          <TabPane tabId="4">
                            <Performance />
                            {/* <Performance yearSelected={yearSelected.value} /> */}
                            
                            {/* <Col sm="12">
                              <div>
                                <BootstrapTable
                                  id="flow-selection-table-6"
                                  keyField="Id"
                                  data={listDataPerformance}
                                  columns={columnsPerformance}
                                  headerClasses="header-style"
                                  // rowStyle={RowStyleFontWhite}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  hover
                                />
                              </div>
                            </Col> */}
                          </TabPane>

                          <TabPane tabId="5">
                            <AccImbalance/>

                            {/* dateSelected={dateSelected}
                              column={[{
                                // "PID": "b6528e52-74da-4710-87bb-e64a33b091fe",
                                "BALANCECOLUMN_ORDER": 1,
                                "BALANCECOLUMN_NAME": "Min Inventory",
                                // "BALANCECOLUMN_DESC": "FUEL",
                                "BALANCECOLUMN_SHOW": true,
                                "PRIORITY_FLAG": 0,
                                "STATUS_FLAG": 0,
                                // "CREATE_USER": "test",
                                // "CREATE_DATE": "2022-02-11T14:28:40.457",
                                // "UPDATE_USER": "test",
                                // "UPDATE_DATE": "2022-02-28T14:14:56.62"
                              }]}
                              zone={zoneList}
                              shipper={shipperList} */}

                          </TabPane>


                        </TabContent>
                      </Row>

                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            {/*start : DataConfirmModal */}
            <Modal size="lg" isOpen={pageDataConfirmModal}>
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Confirm
                </h5>
              </div>
              <div className="modal-body p-0">
                <CardBody className="p-3">
                  <Form>
                    <Row>
                      <div className="modal-body text-center p-0">
                        <h4>มีการเปลี่ยนข้อมูลในตาราง</h4>
                        <br />
                        <h4>คุณต้องการบันทึกการเปลี่ยนแปลงหรือไม่ ?</h4>
                      </div>
                    </Row>
                  </Form>
                </CardBody>
                <div className="modal-footer">
                  <button type="button" className="btn btn-success me-2">
                    <i className="fas fa-check"></i>&nbsp; Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => dataConfirmModal(false)}
                  >
                    <i className="fas fa-times fa-lg"></i>&nbsp; Cancel
                  </button>
                </div>
              </div>
            </Modal>
            {/*end : PageAdd */}
          </Row>
        </Container>
      </div >

      {/*end : PageAdd */}
    </React.Fragment >
  );
}

OtherKeyinData.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ OtherKeyinData }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OtherKeyinData));
